define.alias("checkout/components/seamless-checkout", "settings/components/seamless-checkout");